import React from 'react'

import FAQ from 'src/components/Faq'

import pageContext from '../../pageContext.json'
import { Section } from './style'

const Faq = (): React.ReactElement => (
  <Section className="py-5" id="perguntas-frequentes">
    <div className="container">
      <div className="row">
        <div className="col-12">
          <h2 className="text-grayscale--500 text-center">O que você precisa saber?</h2>
          <p className="text-grayscale--500 text-center">
            As respostas que você procura, organizadas para economizar seu tempo.
          </p>
          <FAQ answerData={pageContext.faq.topics} columns={{ lg: 1, xl: 1 }} />
        </div>
      </div>
    </div>
  </Section>
)

export default Faq
